import React, { useCallback, useEffect } from 'react'
import { Button } from '@/atoms/Button'
import { paths } from '@/constants/paths'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

export const ErrorFallback: React.FC = () => {
  const { t } = useTranslate('common')
  useEffect(() => {
    window?.scrollTo?.(0, 0)
  }, [])

  const { push } = useSafeRouter()

  const goHome = useCallback(() => {
    return push(paths.home)
  }, [push])

  return (
    <div className="w-full bg-core-gray-950">
      <div className="mx-auto py-48 text-center text-white md:max-w-[600px]">
        <h2 className="mb-4 text-3xl font-semibold">
          <Translate i18nKey="sorryAboutThat" t={t}>
            Sorry about that.
          </Translate>
        </h2>
        <div className="leading-6">
          <div className="mb-4">
            <Translate i18nKey="looksLikeWeveRunIntoAnUnexpectedIssueOurDevelopersHaveBeenNotified" t={t}>
              Looks like we&apos;ve run into an unexpected issue.
              <div>Our developers have been notified and will work to prevent this from happening in the future.</div>
            </Translate>
          </div>
          <div className="mb-12">
            <div>
              <Translate i18nKey="toReturnToAngelsHomePageClickBelow" t={t}>
                To return to Angel&apos;s home page, click below.
              </Translate>
            </div>
          </div>
        </div>
        <div className="flex w-full justify-center">
          <Button variant="white" outline onClick={goHome}>
            {t('goHome', 'Go Home')}
          </Button>
        </div>
      </div>
    </div>
  )
}
